import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
import { useFragment } from 'react-relay/hooks';

import { Table, TableBody } from '@material-ui/core';
import { TableProps } from '@material-ui/core/Table';
import { graphql } from 'babel-plugin-relay/macro';
import { compact, isEmpty, map } from 'lodash';

import { EmptyStateTable, TableHeadMessages } from 'components/v2';

import { TableMessagesReceived_Query$key } from './__generated__/TableMessagesReceived_Query.graphql';
import TableRowMessage from './TableRowMessage';

const messages = defineMessages({
  emptyStateMessage: {
    id: 'deprecated.fragments.TableMessagesReceived.emptyStateMessage',
    defaultMessage: 'No responses yet',
  },
});

export interface TableMessagesReceivedProps extends Omit<TableProps, 'classes'> {
  fragmentRef: TableMessagesReceived_Query$key;
}

const TableMessagesReceived: React.FC<TableMessagesReceivedProps> = ({ fragmentRef, ...rest }) => {
  const { messagesReceived } = useFragment<TableMessagesReceived_Query$key>(
    graphql`
      fragment TableMessagesReceived_Query on Query
        @argumentDefinitions(createdAtFrom: { type: "Date!" }, createdAtTo: { type: "Date!" }) {
        messagesReceived: messageMany(
          limit: 5
          sort: _ID_DESC
          filter: {
            type: inbound
            _operators: {
              createdAt: { gte: $createdAtFrom, lte: $createdAtTo }
              status: { ne: skipped }
              key: { nin: ["interactiveVoiceResponse"] }
            }
          }
        ) {
          _id
          ...TableRowMessage_Message
        }
      }
    `,
    fragmentRef,
  );

  const { formatMessage } = useIntl();

  if (isEmpty(messagesReceived)) {
    return <EmptyStateTable>{formatMessage(messages.emptyStateMessage)}</EmptyStateTable>;
  }
  return (
    <Table {...rest}>
      <TableHeadMessages />
      <TableBody>
        {map(compact(messagesReceived), (message) => (
          <TableRowMessage fragmentRef={message} key={message._id} />
        ))}
      </TableBody>
    </Table>
  );
};

export default TableMessagesReceived;
